import { Link as LinkIcon } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';

const FieldviewChip = () => {
    return (
        <Stack
            direction='row'
            spacing={1}
            p={1}
            alignItems='center'
            sx={{
                borderRadius: '100px',
                border: (t) => `1px solid ${t.palette.divider}`,
                minHeight: '32px',
                width: 'max-content',
            }}
        >
            <Box width='20px' height='20px'>
                <Icon type='fieldview' style={{ fill: '#F7B618', width: '20px', height: '20px' }} />
            </Box>
            <Typography color='primary' variant='body2'>
                {_('Conectado con Fieldview')}
            </Typography>
            <LinkIcon color='success' />
        </Stack>
    );
};

export default FieldviewChip;
